import { footerReducer } from './footer';
import { contentReducer } from './content';
import { pointsReducer } from './points';
import { combineReducers } from 'redux';

export const Reducers = combineReducers({
  footerState: footerReducer,
  contentState: contentReducer,
  pointsState: pointsReducer,
});